import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from '@/components/rw/tempTable/index';
import tempSearch from '@/components/rw/tempSearch/index';
import tempForm from '@/components/rw/tempForm/index';
import tempChart from '@/components/rw/tempChart/index';
import { refreshReport, systemReportGroup, systemReportList } from '../../../../api/apis';
export default {
  name: 'sr2',
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  data: function data() {
    var _this = this;

    return {
      searchType: 0,
      searchModel_1001: {
        "type": "searchTemplate",
        "id": "id_1001",
        "del": false,
        "searchData": [{
          "children": [{
            "field": [{
              "desc": "期数",
              "key": "expect_num",
              "value": ""
            }],
            "operator": ["gte", "lte", "gt", "lt", "eq", "ne", "like", "notLike", "in", "between"],
            "placeholder": "请输入",
            "type": "input-complex"
          }],
          "id": 3,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "按条件",
          "type": 2,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [{
              "desc": "类型一",
              "key": "type",
              "value": "0"
            }, {
              "desc": "类型二",
              "key": "type",
              "value": "1"
            }],
            "multiple": true,
            "type": "select"
          }],
          "id": 4,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "派系(多选)",
          "type": 3,
          "remoteFunc": ["modelConditionFunc_4"]
        }],
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "isCollapse": false
      },
      tableModel_1000: {
        "border": true,
        "del": false,
        "headerButton": [],
        "id": "id_1000",
        "isGroup": false,
        "isTree": false,
        "rowButton": [],
        "showPagination": true,
        "showSelection": false,
        "showSummary": true,
        "stripe": true,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "日期",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "add_time"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "派系名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "group_name"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "派系编号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "group_number"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "拨比",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": 80,
          "prop": "bobi"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "新增人数",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "curr_pnum"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "我要发货",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "order_num"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "一品达人晋级30盒",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "bonus16"
        }, {
          "add": 0,
          "detail": 0,
          "excel": 0,
          "groupId": "",
          "label": "报单金额（折扣前）",
          "rowAddField": "",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "130",
          "prop": "original_price"
        }, {
          "add": 0,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "",
          "label": "报单金额（折扣后）",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "130",
          "prop": "order_money"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 0,
          "groupId": "",
          "label": "定级居间账户余额",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "100",
          "prop": "money1"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 0,
          "groupId": "",
          "label": "进货居间账户余额",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "100",
          "prop": "money2"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "实发奖金",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "curr_send_bonus"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "云仓进货盒数",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "order_product_num"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "合约仓进货盒数",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus1"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "进货盒数*1680",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "bonus15"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "进货金额",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus2"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "超越奖",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus3"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "平级奖",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus4"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "贡献奖",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "120",
          "prop": "bonus5"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "业绩级差奖",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus6"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "见点奖",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus17"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "大V奖",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus7"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "提现金额",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bonus8"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整增加(云仓)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "130",
          "prop": "bonus9"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整减少(云仓)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "130",
          "prop": "bonus10"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整增加(合约)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "bonus11"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整减少(合约)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "bonus12"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整增加(欠货)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "bonus13"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "调整减少(欠货)",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "bonus14"
        }, {
          "label": "剩余合约仓数量",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "bonus18"
        }],
        "tableName": "t_total_report",
        "tableRadioProps": {},
        "tableSelectProps": {},
        "tableSwitchProps": {},
        "title": "系统总报表",
        "type": "tableTemplate"
      },
      remoteFunc: {
        modelConditionFunc_4: function modelConditionFunc_4(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [{
            key: 'group_number',
            value: 'B49981660',
            desc: '义系-贾红英'
          }, {
            key: 'group_number',
            value: 'B78869475',
            desc: '义系-刘春梅'
          }, {
            key: 'group_number',
            value: 'B57674849',
            desc: '智系-孙肖'
          }, {
            key: 'group_number',
            value: 'B27917835',
            desc: '信系-王树颖'
          }, {
            key: 'group_number',
            value: 'B24586540',
            desc: '礼系-徐敏'
          }, {
            key: 'group_number',
            value: 'B72260199',
            desc: '仁系-黄金库'
          }, {
            key: 'group_number',
            value: 'B84167861',
            desc: '礼系-周建申'
          }];
          resolve(tag, [data]);
        }
      }
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where, res, rows, i, key;
      return regeneratorRuntime.async(function reqTableData$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              where = {};

              if (this.search) {
                where = this.search.parseWhere();
                params.where = where;
              }

              if (!(!params.where.hasOwnProperty("group_number") || !params.where.hasOwnProperty("expect_num"))) {
                _context.next = 5;
                break;
              }

              resolve({
                total: 0,
                data: []
              });
              return _context.abrupt("return");

            case 5:
              params.expect_num = params.where.expect_num;
              params.group_number = params.where.group_number;
              delete params.where;
              _context.next = 10;
              return regeneratorRuntime.awrap(systemReportGroup(params));

            case 10:
              res = _context.sent;
              rows = res;

              for (i in rows) {
                // rows[i].bobi = (rows[i].bobi*100) + '%'
                rows[i].bonus15 = rows[i].order_product_num * 1680;

                for (key in rows[i]) {
                  if (rows[i][key] == null) {
                    rows[i][key] = 0;
                  }
                }
              }

              resolve({
                total: 0,
                data: rows
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {//if (isEdit){
      //  params.id = row.id
      //}
      //xxxAdd(params).then(async res=>{
      //  resolve()
      //})
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {
      var _this2 = this;

      //点击列表按钮回调
      refreshReport({
        date: row.key_date
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$message({
                  message: '刷新成功',
                  type: 'success'
                });

                _this2.table.reloadData();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {
      //列表尾部合计回调
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        }) && index > 2) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      return true;
    }
  }
};